
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/klient-obslugiwany",
      function () {
        return require("private-next-pages/klient-obslugiwany.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/klient-obslugiwany"])
      });
    }
  